import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'ceres-search-field',
    templateUrl: './search-field.component.html',
    styleUrls: ['./search-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchFieldComponent implements OnInit, OnDestroy {
    @Input() dataSource: MatTableDataSource<object> = new MatTableDataSource();
    @Input() isStyleModern = false;
    @Input() fixMargin = false;

    inputQueryChanged: Subject<string> = new Subject<string>();
    filter = '';

    ngOnInit() {
        this.subscribeToInputChanges();
        this.dataSource.filterPredicate = (data, filter) => {
            const dataToFilter = JSON.stringify(data);
            if (dataToFilter && filter) {
                return dataToFilter.toLowerCase().includes(filter.toLowerCase());
            }
            return false;
        };
    }

    ngOnDestroy(): void {
        this.inputQueryChanged.unsubscribe();
    }

    public resetFilter() {
        this.dataSource.filter = '';
        this.filter = '';
    }

    private subscribeToInputChanges(): void {
        this.inputQueryChanged.pipe(debounceTime(750), distinctUntilChanged()).subscribe((filterValue) => {
            this.dataSource.filter = String(filterValue);
        });
    }

    protected onFilterChange(filter: string): void {
        this.filter = filter;
        this.inputQueryChanged.next(filter);
    }
}
